export default {
  functional: true,
  props: {
    size: { type: String, default: '', required: false },
    type: { type: String, default: 'button', required: false },
    text: { type: Boolean, default: false, required: false },
    outline: { type: Boolean, default: false, required: false },
    danger: { type: Boolean, default: false, required: false },
    gray: { type: Boolean, default: false, required: false },
    disabled: { type: Boolean, default: false, required: false },
    loading: { type: Boolean, default: false, required: false }
  },
  render(h, { props, listeners, children }) {
    const tagName = 'button'

    const data = {
      class: {
        'button' : true,
        'waves-effect': true,
        'waves-light': !props.text,
        'small': props.size === 'small',
        'xsmall': props.size === 'xsmall',
        'text': props.text,
        'is-outlined': props.outline,
        'is-loading': props.loading,
        'is-danger': props.danger,
        'is-secondary': props.gray
      },
      attrs: {
        type: props.type,
        disabled: props.disabled || props.loading
      }
    }

    // クリックイベントの受け渡し
    if (typeof listeners.click !== 'undefined') {
      data.on = {
        click: listeners.click
      }
    }

    return h(tagName, data, children)
  }
}
